
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
// import {language_return} from '../../JSfiles/inventory/ItemLabelsLoad'

import InitialPage from "../Request/InitialPage";
import CallCenterPage from "../Request/CallCenterPage";
import ComplaintPage from "../Request/complaint/ComlpaintPage";
import Menu_1 from "../Request/complaint/Menu_1";
import newtIcon from "../../../SVG_images/new.svg";
import { AiOutlineArrowLeft, AiOutlineArrowRight, AiOutlineBorderBottom, } from "react-icons/ai";
import saveIcon from "../../../SVG_images/save.svg";
import editIcon from "../../../SVG_images/edit.svg";
import attacmentsIcon from "../../../SVG_images/attachment.png";
import remarksIcon from "../../../SVG_images/note.png";
import { BsThreeDotsVertical } from "react-icons/bs";
  

import { useSelector } from "react-redux"; //to get the value from the redux

import { Dropdown, Collapse } from "react-bootstrap";

const CallCenter = () => {
  /*const [PageMode, setPageMode] = useState("initial")*/
  const [PageMode, setPageMode] = useState("");
  const [requesInitialstData, setRequesInitialstData] = useState();
  const [requestTypetData, setrequestTypetData] = useState();
  const [customerTypetData, setCustomerTypetData] = useState();
  const [listMode, setlistMode] = useState("my role");
  const [RequestsListData, setRequestsListData] = useState();
  const [requestData, setRequestData] = useState();
  const [invoiceData, setInvoiceData] = useState();
  const [requestMode, setRequestMode] = useState("");
  const [requestType, setrequestType] = useState();
  const [clienttData, setclienttData] = useState();
  const [requestdetail, setRequestdetail] = useState({});
  const [open, setOpen] = useState(false);
  const [openInvoices, setOpenInvoices] = useState(false);

   const dispatch = useDispatch();
   

    const [RequestInput, setRequestInput] = useState({
    request_year: 0,
    branch_cd: 0,
    request_cd: 0,
    });

    const { user } = useSelector((state) => {
    return state;
    });

    useEffect(() => {  
        setlistMode("")
        getRequestInitial();
    }, []);

    const set_edit_mode = () => {
        setRequestMode("Edit");
        document.getElementById("edit_status").innerText = "Edit";
    
    };

    const go_to_request = (request_year, branch_cd, request_cd) => { 
        alert("change onClick triger")
        setRequestInput({ request_year: request_year, branch_cd: branch_cd, request_cd: request_cd, });
        setPageMode("Request");
    };

    const set_clear_mode = () => {
    setPageMode("Initial");
    };

    const phone_keyEvent = (e) => {
        if (e.charCode === 13) {
          get_client_details_and_invoices(requestdetail.phone_no);
        }
  };

  /*Read ------------*/
    const getRequestInitial = async () => {
        try {
            let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));
            const data = {
                info: {
                lang: userDataLocal.lang,
                company: userDataLocal.company_cd,
                user_cd: userDataLocal.user_cd,
            },
            input: {
                actioncode: "get_request_initials",
            },
        };

        console.log("get_request_initials input ", data)

        let res = await axios.post(
            `${process.env.REACT_APP_BACK_END_URL}/api/iip/wf/get_request_initials`,
            data,
            {
            headers: {
                Authorization: `Bearer ${userDataLocal.token}`,
            }
        }
        );
        console.log("get_request_initials output ", res)

        if(res.data.output.request_type && res.data.output.request_type.length > 0){setrequestTypetData(res.data.output.request_type)}
        if(res.data.output.customer_type && res.data.output.customer_type.length > 0){setCustomerTypetData(res.data.output.customer_type)}
        setRequesInitialstData(res.data.output);
        setPageMode("Initial")
       
        } catch (err) {
        console.log(err);
        alert("error message" + err.message);
        }
    };

    const get_client_request = async (area_code, mobile_no) => {
        try {
            let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));
            const data = {
                info: {
                    lang: userDataLocal.lang,
                    company: userDataLocal.company_cd,
                    user_cd: userDataLocal.user_cd,
                },
                input: {
                    actioncode: "get_client_requests",
                    country_area_cd: area_code,
                    mobile_no: mobile_no,
                },
            };
            let res = await axios.post(
            `${process.env.REACT_APP_BACK_END_URL}/api/iip/wf/get_client_requests`,
            data,
            );

            console.log("client requests", res);
            setRequestsListData(res.data.output);
            setlistMode("client requests");
        } catch (err) {
            console.log(err);
            alert("error message" + err.message);
        }
    };

    const get_my_role = async () => {
        setlistMode("my role");
    };

    const get_new_task = async () => {
        setlistMode("new task");
      };

    const getrequest = async (request_year, branch_cd, request_cd) => {
      
        try {
            let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));
            const data = {
                info: {
                    lang: userDataLocal.lang,
                    company: userDataLocal.company_cd,
                    user_cd: userDataLocal.user_cd,
                },
                input: {
                    actioncode: "get_request_details",
                    request_year: request_year,
                    branch_cd: branch_cd,
                    request_cd: request_cd,
                },
            };

            console.log("getrequest input", data);
            let res = await axios.post(
            process.env.REACT_APP_BACK_END_URL + "/api/iip/wf/get_request_details",
                data,
                {
                    headers: {
                        Authorization: `Bearer ${userDataLocal.token}`,
                }
            }
        );

        console.log("getrequest output", res);
        if(res.data.output){setRequestData(res.data.output)}
        setInvoiceData(res.data.output);

        var request = res.data.output.request_details;
        setRequestMode("View");
        if (request.request_type_cd == 1) {
            setrequestType("Complaint Request");
        } else {
            setrequestType("Common Request");
        }
        setPageMode("Request");

    } catch (err) {
      console.log(err);
      alert("error message" + err.message);
    }
  }

    const get_client_details = async (phone_no) => {
    //setclienttData();
    try {
        let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));
        /*let client_mobil_no = document.getElementById('client_mobile').value*/
        const data = {
            info: {
                lang: userDataLocal.lang,
                company: userDataLocal.company_cd,
                user_cd: userDataLocal.user_cd,
            },
            input: {
                actioncode: "get_client_invoices",
                country_area_cd: "965",
                mobile_no: phone_no,
            },
        };

        console.log("get_client_details data", data);
        
        let res = await axios.post(
        `${process.env.REACT_APP_BACK_END_URL}/api/v1/fin/get_client_invoices`,
        data,
        );

        console.log("get_client_details output", res);
        return
        if (res.data.output.client_name) {
        setclienttData(res.data.output);
        } else {
        alert("no data");
        }
        
    
    } catch (err) {
        console.log(err);
        alert("error message" + err.message);
    }
    };

    const get_client_details_and_invoices = async (mobile_no) => {
        alert("okay")
    /*setclienttData();*/
    try {
        let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));
        /*let client_mobil_no = document.getElementById('client_mobile').value*/
        const data = {
            info: {
                lang: userDataLocal.lang,
                company: userDataLocal.company_cd,
                user_cd: userDataLocal.user_cd,
            },
            input: {
                actioncode: "get_client_invoices",
                country_area_cd: "965",
                mobile_no: mobile_no,
            },
        };
        console.log("get_client_details_and_invoices input", data);

        let res = await axios.post(
        `${process.env.REACT_APP_BACK_END_URL}/api/v1/fin/get_client_invoices`,
        data,
        );
        console.log("get_client_details_and_invoices output", res);
        if (res.data.output.client_name) {
            setclienttData(res.data.output);
        } else {
            alert("no data");
        }
        
    } catch (err) {
        console.log(err);
        alert("error message" + err.message);
    }
  };

    const setInvoice = async (invoice_year, branch_cd, invoice_cd) => {
        document.getElementById("invoice_no").innerHTML = "INV-" + invoice_year + "-" + branch_cd + "-" + invoice_cd 
        document.getElementById("invoice_collapse").style.display = "none";

        try {
            let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));

            const data = {
            info: {
                lang: userDataLocal.lang,
                company: userDataLocal.company_cd,
                user_cd: userDataLocal.user_cd,
            },
            input: {
                actioncode: "get_invoice",
                invoice_year: "2022",
                branch_cd: "69",
                invoice_cd: "1",
            },
            };
            let res = await axios.post(
            `${process.env.REACT_APP_BACK_END_URL}/api/v1/fin/get_invoice`,
            data,
            );

            console.log("invoice", res);
            setInvoiceData(res.data.output);
        } catch (err) {
            console.log(err);
            alert("error message" + err.message);
        }
    };
    
    return (
        <>
            <div>
            <div className="row">
                <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 border-right">
                    <div className="panel-body  mostly-customized-scrollbar start_padding">
                        {PageMode === "Initial" && (
                            <div>
                                <div className="request_menu_line" onClick={() => { get_client_request("965", "65133329")}}>
                                    <div className="request_menu_item">search</div>
                                </div>
                                <div className="request_menu_line" onClick={() => {setPageMode("Request"); setRequestMode("Draft");}}>
                                    <div className="request_menu_item"> <img src={newtIcon} className="buton_icon" /> New Request </div>
                                </div>
                                <div className="request_menu_line" onClick={() => {get_new_task();}}>
                                    <div className="request_menu_item"> <img src={newtIcon} className="buton_icon" /> New Tasks </div>
                                </div>
                                <div className="request_menu_line" onClick={() => {get_my_role()}}>
                                    <div className="request_menu_item"> <img src={newtIcon} className="buton_icon" /> My Role </div>
                                </div>
                                <div className="request_menu_line bottom_line">
                                    <div className="request_menu_item"> <img src={newtIcon} className="buton_icon" /> recent opend Requests </div>
                                </div>
                                <div className="request_menu_line" onClick={() => { getrequest(2022, 9, 1) }} >
                                    <div className="request_menu_item">First request</div>
                                </div>
                                <div className="request_menu_line" onClick={() => { getrequest(2022, 9, 2) }} >
                                    <div className="request_menu_item">Second request</div>
                                </div>
                            </div>
                        )}
                        {PageMode === "Request" && (
                            <div>
                            Progress detals
                            </div>
                        )}
                    </div>     
                </div> 
                <div className="col-sm-12 col-md-8 col-lg-8 col-xl-8">
                    {PageMode === "Initial" && (
                        <div>
                            {listMode === "client requests" && (
                                <>
                                    <table className="table table-hover">
                                        <thead>
                                        <tr>
                                            <th style={{ width: "15%" }}>Request Time</th>
                                            <th style={{ width: "45%" }}>Request Desc.</th>
                                            <th style={{ width: "20%" }}>Request Type</th>
                                            <th style={{ width: "20%" }}>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {RequestsListData.requests_list.length >= 0 && RequestsListData.requests_list.map( (client_requests, index) => (
                                                <tr onClick={() => { go_to_request( client_requests.request_year, client_requests.branch_cd, client_requests.request_cd ) }}>
                                                    <td>{client_requests.request_time}</td>
                                                    <td>{client_requests.requext_text}</td>
                                                    <td>{client_requests.request_type}</td>
                                                    <td>{client_requests.request_status}</td>
                                                </tr>
                                            ),
                                            )}
                                        </tbody>
                                    </table>
                                </>
                            )}
                            {listMode === "new task" && (
                                <>
                                <div>Tew Task</div>
                                </>
                            )}
                            {listMode === "my role" && (
                                <>
                                <div>my role</div>
                                </>
                            )}
                        </div>
                    )}
                    {PageMode === "Request" && (
                        <div>
                            <div id="request_header" className="buttons_div ">
                                <div className="subbutton_div normal_float" onClick={set_clear_mode}>
                                    <div className="buton_icon normal_float"> {" "} <AiOutlineArrowLeft style={{ fontSize: "18px" }} /></div>
                                    <div id="edit_status" className="normal_float"></div>
                                    <div style={{ clear: "both" }}></div>
                                </div>
                                <div className="subbutton_div normal_float" style={{ paddingLeft: "10px", borderLeft: "solid 1px gray" }} >
                                    <div id="request_type_name" className=" normal_float"></div>
                                    <div id="request_code" className=" normal_float" style={{ paddingRight: "20px", paddingLeft: "2px" }}></div>
                                    <div style={{ clear: "both" }}></div>
                                </div>
                                <div id="request_buttons" className="opposite_float subbutton_div">
                                    {requestMode === "View" && (<BsThreeDotsVertical className="buton_icon opposite_float" />)}
                                    {(requestMode === "Edit" || requestMode === "Draft") && (<img id="item_save_btn" src={saveIcon} className="buton_icon opposite_float "/>)}
                                    {requestMode === "View" && (
                                        <>
                                        <img src={remarksIcon} className="buton_icon opposite_float" onClick={() => { dispatch({ type: "attachmentInfo",payload: { data1: "good morening" }, })}} alt=""/>
                                        <img src={attacmentsIcon} className="buton_icon opposite_float" onClick={() => { dispatch({ type: "attachmentInfo", payload: { data1: "good morening" }, });}}  alt=""/>
                                        <img src={editIcon} className="buton_icon opposite_float" onClick={() => { set_edit_mode() }}  alt=""/>
                                        </>
                                    )}
                                    <div style={{ clear: "both" }}></div>
                                </div>
                                <div style={{ clear: "both" }}></div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-8 col-xl-7">
                                {requestMode === "Draft" && (
                                    <>
                                        <div style={{display:"flex", alignItems:"center"}}>
                                        <input id="client_mobile" type="text" className="editing_field" style={{ outline: "none", width:"40px"}} value="965"/>
                                        <input type="text" className="editing_field" style={{ outline: "none", width:"auto" }} autoComplete="0" placeholder="Client Phone"
                                            value={requestdetail && requestdetail.phone_no} onChange={(e) =>  setRequestdetail({ ...requestdetail, phone_no: e.target.value })}  onKeyPress={phone_keyEvent} />
                                        </div>


                                        <table className="table-verticle-middle table-frm table-frm-ed">
                                        <tbody>
                                            <tr>
                                            <th style={{ width: "35%" }} />
                                            <th style={{ width: "65%" }} />
                                            </tr>
                                            
                                            
                                            {clienttData && (
                                            <tr>
                                                <th id="client_name_l" style={{ verticalAlign: "top" }}>Client</th>
                                                <td>
                                                <div className="form-control  input-sm ">
                                                    <div>
                                                    <div id="client_name" className="normal_float field_text_alighn" >{clienttData.client_name}</div>
                                                    <div className="opposite_float" onClick={() => setOpen(!open)} aria-controls="example-collapse-text" aria-expanded={open}>X</div>
                                                    <div style={{ clear: "both" }}></div>
                                                    </div>
                                                    <Collapse in={open}>
                                                    <div id="example-collapse-text" className="field_text_alighn" style={{ marginTop: "10px" }}>
                                                        {clienttData.country_area_cd + " " + clienttData.mobil_no}
                                                        <br />
                                                        {clienttData.email_address}
                                                        <br />
                                                        {clienttData.country_name + ", " + clienttData.state_name + ", " + clienttData.city_name}
                                                        <br />
                                                        {clienttData.client_address}
                                                    </div> </Collapse> 
                                                </div>
                                                </td>
                                            </tr>
                                            )}
                                            {clienttData && (
                                            <tr>
                                                <th id="invoice_no_l" style={{ verticalAlign: "top" }}>Invoice No.</th>
                                                <td>
                                                <div className="form-control  input-sm ">
                                                    <div>
                                                    {clienttData && clienttData.client_invoices.length == 1 && (
                                                        <div id="invoice_no" className="normal_float field_text_alighn">
                                                            {"INV -" + clienttData && clienttData.client_invoices[0].invoice_year + "-" + clienttData && clienttData.client_invoices[0].branch_cd + "-" + clienttData.client_invoices[0].invoice_cd}
                                                        </div>
                                                    )}
                                                    {clienttData && clienttData.client_invoices && clienttData.client_invoices.length >= 1 && (
                                                        <div>
                                                            <div id="invoice_no" className="normal_float field_text_alighn" ></div>
                                                            <div className="opposite_float" aria-controls="invoice_collapse" aria-expanded={openInvoices} onClick={() => setOpenInvoices(!openInvoices)} >X</div>
                                                            <div style={{ clear: "both" }}></div>
                                                        </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <Collapse in={openInvoices}> <div id="invoice_collapse" className="field_text_alighn input-sm">
                                                    {clienttData && clienttData.client_invoices && (
                                                        <div style={{ pading: "10px", marginTop: "15px" }} >
                                                        <table className="table table-hover">
                                                            <thead>
                                                            <tr>
                                                                <th style={{ width: "50%" }}> Invoice No. </th>
                                                                <th style={{ width: "50%" }}> Invoice Date </th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {clienttData && clienttData.client_invoices.length > 0 && clienttData.client_invoices.map( (invoices, index) => (
                                                                    <tr onClick={() => setInvoice( invoices.invoice_year, invoices.branch_cd, invoices.invoice_cd, ) } >
                                                                    <td className="field_text_alighn">
                                                                        {"INV-" + invoices.invoice_year + "-" + invoices.branch_cd + "-" + invoices.invoice_cd}{" "}
                                                                    </td>
                                                                    <td className="field_text_alighn">
                                                                        {invoices.invoice_date}
                                                                    </td>
                                                                    </tr>
                                                                ),
                                                                )}
                                                            </tbody>
                                                        </table>
                                                        </div>
                                                    )}
                                                    </div>
                                                </Collapse>
                                                </td>
                                            </tr>
                                            )}
                                            <tr>
                                            <th id="request_desc_l">Complaint Desc.</th>
                                            <td></td>
                                            </tr>
                                            <tr>
                                            <td colSpan="2">
                                                <textarea id="requext_text_v" className="form-control input-sm" style={{ width: "100%", height: "70px" }} Placeholder="enter the complaint her" ></textarea>
                                            </td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </>
                                )}

                                {requestData && (
                                    <>
                                        <table className="table-verticle-middle table-frm table-frm-ed">
                                        <tbody>
                                            <tr>
                                            <th style={{ width: "35%" }} />
                                            <th style={{ width: "65%" }} />
                                            </tr>

                                            {(requestMode === "Edit" || requestMode === "Draft") && (
                                            <>
                                                <tr>
                                                <th id="requested_by_l">Requested By</th>
                                                <td>
                                                    <div id="request_user_name_v" className="form-control input-sm view_field_no_border field_text_alighn " >
                                                    {requestData.request_details.request_user_name}
                                                    </div>
                                                </td>
                                                </tr>
                                                <tr>
                                                <th id="request_type_cd_l">Request Type</th>
                                                <td>
                                                    <select id="request_type_cd" className="form-control input-sm " selectedValue={ requestData.request_details.request_type_cd } >
                                                    {requestTypetData.length >= 0 && requestTypetData.map((request_type, index) => {
                                                        return (
                                                            <option key={index} value={request_type.request_type_cd} >
                                                            {request_type.request_type}
                                                            </option>
                                                        );
                                                        })}
                                                    </select>
                                                </td>
                                                </tr>
                                                <tr>
                                                <th id="customer_type_cd_l">Applicant Type</th>
                                                <td>
                                                    {console.log( "code = ", requestData.request_details.code, )}
                                                    <select id="customer_type_cd" className="form-control input-sm " selectedValue={requestData.request_details.code} >
                                                    {customerTypetData.length >= 0 &&
                                                        customerTypetData.map((customer, index) => {
                                                        return (
                                                            <option key={index} value={customer.code}>
                                                            {customer.name_txt}
                                                            </option>
                                                        );
                                                        })}
                                                    </select>
                                                </td>
                                                </tr>
                                                <tr>
                                                <th id="customer_id_l">Mobile</th>
                                                <td>
                                                    <input id="client_mobile" type="text" className="form-control input-sm" style={{ outline: "none" }} placeholder="Client Mobile" autoComplete="0" onChange={get_client_details} />
                                                </td>
                                                </tr>
                                                {clienttData && (
                                                <tr>
                                                    <th id="client_name_l" style={{ verticalAlign: "top" }} >
                                                    Client
                                                    </th>
                                                    <td>
                                                    <div className="form-control  input-sm ">
                                                        <div>
                                                        <div id="client_name" className="normal_float field_text_alighn" >
                                                            {clienttData.client_name}
                                                        </div>
                                                        <div className="opposite_float" onClick={() => setOpen(!open)} aria-controls="example-collapse-text" aria-expanded={open} ></div>
                                                        <div style={{ clear: "both" }}></div>
                                                        </div>
                                                        <Collapse in={open}>
                                                        <div id="example-collapse-text" className="field_text_alighn" style={{ marginTop: "10px" }} >
                                                            {clienttData.country_area_cd +
                                                            " " +
                                                            clienttData.mobil_no}
                                                            <br />
                                                            {clienttData.email_address}
                                                            <br />
                                                            {clienttData.country_name +
                                                            ", " +
                                                            clienttData.state_name +
                                                            ", " +
                                                            clienttData.city_name}
                                                            <br />
                                                            {clienttData.client_address}
                                                        </div>
                                                        </Collapse>
                                                    </div>
                                                    </td>
                                                </tr>
                                                )}
                                                {clienttData && (
                                                <tr>
                                                    <th id="invoice_no_l" style={{ verticalAlign: "top" }} >
                                                    Invoice No.
                                                    </th>
                                                    <td>
                                                    <div className="form-control  input-sm ">
                                                        <div>
                                                            <div id="Ivoive_no" className="normal_float field_text_alighn" ></div>
                                                            <div className="opposite_float" onClick={() => setOpenInvoices(!openInvoices)} aria-controls="invoice_collapse" aria-expanded={openInvoices} >
                                                                X
                                                            </div>
                                                            <div style={{ clear: "both" }}></div>
                                                        </div>
                                                    </div>
                                                    <Collapse in={openInvoices}>
                                                        <div id="invoice_collapse" className="field_text_alighn input-sm" >
                                                        {clienttData.client_invoices && (
                                                            <div style={{ pading: "10px", marginTop: "15px", }} >
                                                            <table className="table table-hover">
                                                                <thead>
                                                                <tr>
                                                                    <th style={{ width: "50%" }}>
                                                                    Invoice No.
                                                                    </th>
                                                                    <th style={{ width: "50%" }}>
                                                                    Invoice Date
                                                                    </th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {/* {clienttData.client_invoices.length >= 0 && clienttData.client_invoices.map((invoices, index) => ( */}
                                                                {/*     <tr onClick={() => setInvoice(invoices.invoice_year, invoices.branch_cd, invoices.invoice_cd)}> */}
                                                                {/*         <td className="field_text_alighn">{"INV-" + invoices.invoice_year + "-" + invoices.branch_cd + "-" + invoices.invoice_cd} </td> */}
                                                                {/*         <td className="field_text_alighn">{invoices.invoice_date}</td> */}
                                                                {/*     </tr> */}
                                                                {/* ) */}
                                                                {/*)  */}
                                                                </tbody>
                                                            </table>
                                                            </div>
                                                        )}
                                                        </div>
                                                    </Collapse>
                                                    </td>
                                                </tr>
                                                )}
                                                <tr>
                                                <th id="request_desc_l">Complaint Desc.</th>
                                                <td></td>
                                                </tr>
                                                <tr>
                                                <td colSpan="2"> 
                                                    <textarea id="requext_text_v" className="form-control input-sm" style={{ width: "100%", height: "70px" }} Placeholder="enter the complaint her" >
                                                        {requestData.request_details.requext_text}
                                                    </textarea>
                                                </td>
                                                </tr>
                                            </>
                                            )}

                                            {requestMode === "View" && (
                                            <>
                                                <tr>
                                                <th id="requested_by_l">Requested By</th>
                                                <td>
                                                    <div id="request_user_name_v" className="form-control input-sm view_field_no_border field_text_alighn " >
                                                    {requestData.request_details.request_user_name}
                                                    </div>
                                                </td>
                                                </tr>
                                                <tr>
                                                <th id="request_type_cd_l">Request Type</th>
                                                    <td>
                                                    <div id="request_type_cd" className="form-control input-sm view_field_no_border field_text_alighn " >
                                                        {requestData.request_details.request_type}{" "}
                                                    </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                <th id="customer_type_cd_l">Applicant Type</th>                          
                                                <td>
                                                    <div id="customer_type_cd" className="form-control input-sm view_field_no_border field_text_alighn " >
                                                       {/* {customerTypetData && customerTypetData.find( (el) => el.code === requestData.request_details.customer_type_cd, ).name_txt }*/}
                                                    </div>
                                                </td>
                                                </tr>
                                                <tr>
                                                <th id="request_desc_l">Complaint Desc.</th>
                                                <td></td>
                                                </tr>
                                                <tr>
                                                <td colSpan="2">
                                                    <textarea id="requext_text_v" className="form-control input-sm" style={{ width: "100%", height: "70px", backgroundColor: "transparent", }} readOnly >
                                                    {requestData.request_details.requext_text}
                                                    </textarea>
                                                </td>
                                                </tr>
                                            </>
                                            )}
                                        </tbody>
                                        </table>
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            
            </div>



            {/*{PageMode === "menu" && <Menu_1 />}*/}
            {/*{PageMode === "initial" && (<InitialPage listMode={listMode} setlistMode={setlistMode} RequestsListData={RequestsListData} setRequestsListData={setRequestsListData} PageMode={PageMode} RequestInput={RequestInput} setRequestInput={setRequestInput} setPageMode={setPageMode}/>)}*/}
            {/*{PageMode === "CallCenterPage" && (<CallCenterPage requestTypetData={requestTypetData} customerTypetData={customerTypetData}  PageMode={PageMode} setPageMode={setPageMode} RequestInput={RequestInput} setRequestInput={setRequestInput}/>)}*/}
            {/*   {PageMode === "request" && <ComplaintPage requesInitialstData={requesInitialstData} requestTypetData={requestTypetData} customerTypetData={customerTypetData} PageMode={PageMode} />}*/}
            </div>
        </>
    );
};

export default CallCenter;
